import { BrokerageIntegrationsDirectory } from '@/components/marketing/brokerage-integrations-directory'
import { MarketingHero } from '@/components/marketing/marketing-hero'
import { brokerageIntegrationsPage } from '@/config/marketing-content/brokerage-integrations'

export function BrokerageIntegrationsPage() {
  return (
    <main>
      <MarketingHero
        eyebrow={brokerageIntegrationsPage.eyebrow}
        title={brokerageIntegrationsPage.heroTitle}
        lead={brokerageIntegrationsPage.heroLead}
        heroImage={brokerageIntegrationsPage.heroImage}
        heroImageMaxWidth={brokerageIntegrationsPage.heroImageMaxWidth}
      />

      <BrokerageIntegrationsDirectory
        brokerages={brokerageIntegrationsPage.brokerages}
        searchPlaceholder={brokerageIntegrationsPage.directorySearchPlaceholder}
        pageSize={brokerageIntegrationsPage.directoryPageSize}
        modalEyebrow={brokerageIntegrationsPage.directoryModalEyebrow}
      />
    </main>
  )
}
